export const typeMeasurement = [
  {
    uom_name: "kg",
    aliases: ["kilogram", "killogram", "kilo"],
    val: "g",
    factor: 1000,
  },
  {
    uom_name: "g",
    aliases: ["gram"],
    val: "g",
    factor: 1,
  },

  {
    uom_name: "litre",
    aliases: ["liter", "litter", "ltr", "l", "lts"],
    val: "ml",
    factor: 1000,
  },
  {
    uom_name: "ml",
    aliases: ["milliliter", "millilitre", "mltr"],
    val: "ml",
    factor: 1,
  },

  {
    uom_name: "pcs",
    aliases: ["pieces", "piece", "pc", "pices", "pces", "pcs", "pic", "pce"],
    val: "count",
    factor: 1,
  },
  {
    uom_name: "dozen",
    aliases: ["12pcs"],
    val: "count",
    factor: 12,
  },
  {
    uom_name: "pack",
    aliases: ["pkt"],
    val: "count",
    factor: 0,
  },
  {
    uom_name: "box",
    aliases: ["bx", "box-100", "box-large", "box-small", "box-type-a"],
    patterns: ["box", "bx"],
    val: "count",
    factor: 0,
  },
  {
    uom_name: "bundle",
    aliases: ["bundal", "bndl", "bundal type a", "bundal type 1"],
    patterns: ["bund", "bndl"],
    val: "count",
    factor: 0,
  },
  {
    uom_name: "feet",
    aliases: ["ft"],
    val: "cm",
    factor: 30.48,
  },
  {
    uom_name: "inch",
    aliases: ["in"],
    val: "cm",
    factor: 2.54,
  },
  {
    uom_name: "meter",
    aliases: ["m", "metre"],
    val: "cm",
    factor: 100,
  },
  {
    uom_name: "cm",
    aliases: ["centimeter", "centimetre"],
    val: "cm",
    factor: 1,
  },
  {
    uom_name: "mm",
    aliases: ["millimeter", "millimetre"],
    val: "cm",
    factor: 0.1,
  },
  {
    uom_name: "yard",
    aliases: ["yrd"],
    val: "cm",
    factor: 91.44,
  },
];

export const typeMinimumMeasurement = [
  { uom_name: "count", val: "count" },
  { uom_name: "cm", val: "cm" },
  { uom_name: "ml", val: "ml" },
  { uom_name: "g", val: "g" },
];
